import { BiMoon } from "react-icons/bi"; 
import { BiSun } from "react-icons/bi"; 

export const Header = ({dark, setDark}) => {

    const toggle = () => {
        setDark(!dark);

        if (dark) {
            document.body.classList.remove('dark');
        } else {
            document.body.classList.add('dark');
        }   
    }   


  return (
    <header className="flex justify-between items-center p-4 bg-gray-800 text-white w-full">   
        <div><h2 className="text-2xl">TODOs</h2></div>
        <div>
            <span onClick={toggle} className="m-6 cursor-pointer">{!dark ? (<BiSun size="30" />) : (<BiMoon size="30" />)}</span>
        </div>
    </header>
  )
}
